/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ReaderFragment } from 'relay-runtime';
import type { FragmentReference } from "relay-runtime";
declare export opaque type RewardsDashboardHeader_tradeFirm$ref: FragmentReference;
export type RewardsDashboardHeader_tradeFirm = {|
  +name: ?string,
  +$refType: RewardsDashboardHeader_tradeFirm$ref,
|};
*/


const node/*: ReaderFragment*/ = {
  "kind": "Fragment",
  "name": "RewardsDashboardHeader_tradeFirm",
  "type": "TradeFirmType",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "name",
      "args": null,
      "storageKey": null
    }
  ]
};
// prettier-ignore
(node/*: any*/).hash = '401fbe6e184639abd29965eafa1eb84c';
module.exports = node;
